import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SecureLinkMetaDataDisplay } from '../models';
import { SecureLinkAuthorization } from '@aiwyn/auth';
import { BaseClient, BaseClientFragment } from '@aiwyn/api';

interface SecureLinkMetaDataResponse {
  contact_client: {
    contact_id: number;
    client: BaseClient;
  }[];

  contact?: {
    id: number;
    contact_info: {
      full_name: string;
    };
  }[];

  staff?: {
    id: number;
    fullName: string;
  }[];
}

@Injectable({
  providedIn: 'root',
})
export class SecureLinkApiService {
  constructor(private readonly apollo: Apollo) {}

  getSecureLinkMetaData(secureLinkAuth: SecureLinkAuthorization): Observable<SecureLinkMetaDataDisplay> {
    const clientFragment: BaseClientFragment = new BaseClientFragment();

    let contactQuery = '';
    if (secureLinkAuth.createdByContactId) {
      contactQuery = `
        contact (where: { id: { _eq: ${secureLinkAuth.createdByContactId} } }) {
          id
          contact_info {
            full_name
          }
        }
      `;
    }

    let staffQuery = '';
    if (secureLinkAuth.createdByStaffId) {
      staffQuery = `
        staff (where: { id: { _eq: ${secureLinkAuth.createdByStaffId} } }) {
          id
          fullName
        }
      `;
    }

    let contactClientQuery = '';
    if (secureLinkAuth.createdForContactId) {
      contactClientQuery = `
        contact_client (where: { contact_id: { _eq: ${secureLinkAuth.createdForContactId} } }) {
          contact_id
          client {
            ...${clientFragment.getName()}
          }
        }
      `;
    }
    return this.apollo
      .query<SecureLinkMetaDataResponse>({
        query: gql`
        query GetSecureLinkMetaData {
          ${contactClientQuery}
          ${contactQuery}
          ${staffQuery}
        }

        ${clientFragment.getDependencyFragments()}
      `,
      })
      .pipe(
        map(({ data }) => ({
          contactsClients: data.contact_client?.map(({ client }) => client) || [],
          creatorEntityName: data.contact?.[0]?.contact_info?.full_name || data.staff?.[0]?.fullName || '',
        })),
      );
  }
}
